import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _templateObject;
var _excluded = ["children"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */

import React from 'react';
import { css, jsx } from '@emotion/react';
import { N200, N500, B400 } from '@atlaskit/theme/colors';
import LinkIcon from '@atlaskit/icon/glyph/link';
import Tooltip from '@atlaskit/tooltip';
import { injectIntl } from 'react-intl-next';
import { headingAnchorLinkMessages } from '../../messages';
export var HeadingAnchorWrapperClassName = 'heading-anchor-wrapper';
var CopyAnchorWrapperWithRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  return jsx("span", _extends({}, rest, {
    className: HeadingAnchorWrapperClassName,
    ref: ref
  }), children);
});
var copyAnchorButtonStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline;\n  outline: none;\n  background-color: transparent;\n  border: none;\n  color: ", ";\n  cursor: pointer;\n  right: 0;\n"])), "var(--ds-icon, ".concat(N500, ")"));
var HeadingAnchor = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(HeadingAnchor, _React$PureComponent);
  var _super = _createSuper(HeadingAnchor);
  function HeadingAnchor() {
    var _this;
    _classCallCheck(this, HeadingAnchor);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      tooltipMessage: '',
      isClicked: false
    });
    _defineProperty(_assertThisInitialized(_this), "setTooltipState", function (message) {
      var isClicked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      _this.setState({
        // TODO: ED-14403 investigate why this does not translate
        tooltipMessage: _this.props.intl.formatMessage(message),
        isClicked: isClicked
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getCopyAriaLabel", function () {
      var copyAriaLabel = headingAnchorLinkMessages.copyAriaLabel;
      return _this.props.intl.formatMessage(copyAriaLabel);
    });
    _defineProperty(_assertThisInitialized(_this), "copyToClipboard", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        var copiedHeadingLinkToClipboard, failedToCopyHeadingLink;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              copiedHeadingLinkToClipboard = headingAnchorLinkMessages.copiedHeadingLinkToClipboard, failedToCopyHeadingLink = headingAnchorLinkMessages.failedToCopyHeadingLink;
              event.stopPropagation();
              _context.prev = 2;
              _context.next = 5;
              return _this.props.onCopyText();
            case 5:
              _this.setTooltipState(copiedHeadingLinkToClipboard, true);
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);
              _this.setTooltipState(failedToCopyHeadingLink);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 8]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "resetMessage", function () {
      _this.setTooltipState(headingAnchorLinkMessages.copyHeadingLinkToClipboard);
    });
    _defineProperty(_assertThisInitialized(_this), "renderAnchorButton", function () {
      return jsx("button", {
        css: copyAnchorButtonStyles,
        onMouseLeave: _this.resetMessage,
        onClick: _this.copyToClipboard,
        "aria-label": _this.state.tooltipMessage,
        type: "button"
      }, jsx(LinkIcon, {
        label: _this.getCopyAriaLabel(),
        size: _this.props.level > 3 ? 'small' : 'medium',
        primaryColor: _this.state.isClicked ? "var(--ds-icon-selected, ".concat(B400, ")") : "var(--ds-icon-subtle, ".concat(N200, ")")
      }));
    });
    return _this;
  }
  _createClass(HeadingAnchor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resetMessage();
    }
  }, {
    key: "render",
    value: function render() {
      var tooltipMessage = this.state.tooltipMessage;
      if (tooltipMessage) {
        // We set the key to the message to ensure it remounts when the message
        // changes, so that it correctly repositions.
        // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
        return jsx(Tooltip, {
          tag: CopyAnchorWrapperWithRef,
          content: tooltipMessage,
          position: "top",
          delay: 0,
          key: tooltipMessage
        }, this.renderAnchorButton());
      }
      return this.renderAnchorButton();
    }
  }]);
  return HeadingAnchor;
}(React.PureComponent);
export default injectIntl(HeadingAnchor);